<template>
    <div class="sc flex column">
        <div class="flex-item chart-title">{{ timeRangeText }}服务类别统计</div>
        <div class="flex grow center">
            <div class="sc-chart">
                <e-charts :options="options"
                    :init-options="initOptions"
                    ref="chart"
                    autoresize />
            </div>
        </div>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import theme from '../components/theme'
import common from './common'
import loopPlayTooltip from '_u/echarts/loop-play-tooltip'

export default {
    name: 'ServiceCount',

    mixins: [theme, common],

    components: {
        ECharts
    },

    props: {
        // 服务类别数据
        list: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            chart: null,
            loopPlayer: null,
            chartData: [],
            serviceType: this.$dict.NULL,
        }
    },

    watch: {
        list: {
            handler() {
                this.setData()
            },
            immediate: true,
        },

        orderDataSource: {
            handler() {
                this.setData()
            },
        },

        options(val) {
            if (this.loopPlayer) {
                this.loopPlayer.startLoop(val)
            }
        },
    },

    computed: {
        initOptions() {
            return {
                renderer: 'canvas'
            }
        },

        options() {
            return {
                color: ['#4585FC', '#58D799', '#0FC0D6', '#FEB64C', '#FF7754', '#A584FF', ],
                tooltip: {
                    trigger: 'item',
                    triggerOn: 'mousemove',
                    // formatter: '{b}: {c} ({d}%)'
                    formatter: function(params, ticket, callback) {
                        return `<div class="osc-bar-tooltip">
                            <div class="osc-bar-tooltip-title">${params.name}</div>
                            <div>${params.percent.toFixed(0)}%</div>
                        </div>`
                    }
                },
                series: [{
                    type: 'pie',
                    radius: ['46%', '65%'],
                    label: {
                        show: true,
                        formatter: '{b}: {c}',
                    },
                    emphasis: {
                        label: {
                            show: true,
                        }
                    },
                    labelLine: {
                        show: true
                    },
                    data: this.chartData,
                }]
            }
        },
    },

    mounted() {
        this.chart = this.$refs.chart
        this.loopPlayer = loopPlayTooltip(this.chart.chart, {
            seriesIndex: 0,
        })
    },

    methods: {
        setData() {
            this.$dict.get("service_type")
                .then(dict => {
                    this.serviceType = dict
                })
                .then(() => {
                    let result = []
                    let data = this.list
                    // 工单类型过滤
                    if (this.orderDataSource && this.orderDataSource != 'all') {
                        data = data.filter(v => v.orderDataSource == this.orderDataSource)
                    }

                    // 按服务类型分组
                    let serviceTypeGroup = data.groupBy('serviceType')
                    Object.keys(serviceTypeGroup).forEach(t => {
                        var list = serviceTypeGroup[t]

                        result.push(list.reduce((acc, v) => {
                            acc.total += v.total

                            return acc
                        }, {
                            total: 0,
                            serviceType: t
                        }))
                    })

                    // 格式处理
                    result = result.map(v => ({
                        value: v.total,
                        name: this.serviceType.val(v.serviceType)
                    }))

                    this.chartData = result
                })
        }
    }
}
</script>
<style lang="less"
    scoped>
@import '../components/theme.less';

.echarts {
    width: 100%;
    height: 100%;
}

.sc {
    height: 100%;

    &-chart {
        width: 376px;
        height: 100%;
    }
}
</style>